<template>
  <el-container class="creator-center">
    <el-header class="header">
      <CreatorHeader />
    </el-header>
    <el-container>
      <div class="main-container">
        <CreatorSidebar />
        <div class="right-wrap">
          <div class="main-content">
            <div class="tab-nav">
              <div class="leftitem">
                <el-tabs v-model="activeTab">
                  <el-tab-pane
                    label="个人资料"
                    name="all"
                    style="font-size: 18px">
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
            <div class="user-profile-container">
              <el-row :gutter="20">
                <el-col :span="15">
                  <p>基本信息</p>
                  <el-form
                    ref="ruleFormRef"
                    :model="form"
                    :rules="rules">

                    <el-form-item
                      label="用户名"
                      :label-width="formLabelWidth"
                      prop="uname">
                      <el-input
                        v-model="form.uname"
                        maxlength="20"
                        style="width: 400px"
                        show-word-limit
                        placeholder="请输入用户名" />
                    </el-form-item>
                    <el-form-item
                      label="职位"
                      :label-width="formLabelWidth"
                      prop="job_title">
                      <el-input
                        v-model="form.job_title"
                        maxlength="50"
                        show-word-limit
                        style="width: 400px"
                        placeholder="请输入你的职位" />
                    </el-form-item>
                    <el-form-item
                      label="公司"
                      :label-width="formLabelWidth"
                      prop="company">
                      <el-input
                        v-model="form.company"
                        maxlength="50"
                        show-word-limit
                        style="width: 400px"
                        placeholder="请输入你的公司" />
                    </el-form-item>
                    <el-form-item
                      label="个人主页"
                      :label-width="formLabelWidth"
                      prop="blog_address">
                      <el-input
                        v-model="form.blog_address"
                        maxlength="50"
                        show-word-limit
                        style="width: 400px"
                        placeholder="请输入你的个人主页" />
                    </el-form-item>

                    <el-form-item
                      label="个人介绍"
                      :label-width="formLabelWidth"
                      prop="description">
                      <el-input
                        v-model="form.description"
                        maxlength="100"
                        style="width: 400px"
                        rows="4"
                        placeholder="请简单的介绍一下自己"
                        show-word-limit
                        type="textarea" />
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="9">
                  <div class="profile-content">
                    <!-- 头像上传区域 -->
                    <div class="avatar-upload">
                      <div class="upload-tips">
                        <!-- <el-avatar
                          :src="userAvatar.userAvatarUrl"
                          :size="100" /> -->
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row
                :gutter="120"
                style="margin-top: 120px">
                <el-col>
                  <el-button
                    type="danger"
                    size="large"
                    @click="submitForm(ruleFormRef)"
                    v-if="userInfo.audit_status ==1"
                    >保存修改</el-button
                  >
                  <el-button v-if="userInfo.audit_status ==2" size="large" type="warning" disabled>审核中</el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive } from "vue";
import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import CreatorSidebar from "@/components/CreatorSidebar.vue";
import CreatorHeader from "@/components/CreatorHeader.vue";
import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";
import axiosInstance from "@/utils/axiosInstance";

// import { useRouter } from 'vue-router'
// const router = useRouter()


const activeTab = ref<string>("all");
const formLabelWidth = "120px";
const SSRData = ref({
  title: "个人头像 - " + WebSite_Name,
  description:
    "默认代码,defaultcode.cn 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。",
  keywords:
    "默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区",
});

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: "description", content: SSRData.value.description },
    { name: "keywords", content: SSRData.value.keywords },
  ],
});

//接口
interface UserInfo {
  uuid: string; // 用户唯一标识
  uname: string;
  ucompany: string;
  job_title: string;
  avatar_url: string;
  blog_address: string;
  description: string;
  isvip: number;
  userlevel: number;
  phone_verified: number;
  wechat_verified: number;
  weibo_verified: number;
  github_verified: number;
  weibo_nickname: string;
  weibo_html_url: string;
  github_nickname: string;
  github_html_url: string;
  followers: number;
  following: number;
  created_at: string;
  audit_status: number;
}

const userInfo = ref<UserInfo>({
  uuid: "",
  uname: "",
  ucompany: "",
  job_title: "",
  avatar_url: "",
  blog_address: "",
  description: "",
  isvip: 0,
  userlevel: 0,
  phone_verified: 0,
  wechat_verified: 0,
  weibo_verified: 0,
  github_verified: 0,
  weibo_nickname: "",
  weibo_html_url: "",
  github_nickname: "",
  github_html_url: "",
  followers: 0,
  following: 0,
  created_at: "",
  audit_status: 1
});

//获取用户简介
const fetchUserInfo = async () => {
  try {
    await axiosInstance
      .get("/api/UserInfo/profile_id", {
        params: { uuid: '1000086' },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          userInfo.value = result.data;
          form.uname = userInfo.value.uname;
          form.company = userInfo.value.ucompany;
          form.job_title = userInfo.value.job_title;
          form.avatar_url = userInfo.value.avatar_url;
          form.blog_address = userInfo.value.blog_address;
          form.description = userInfo.value.description;
          form.uuid = userInfo.value.uuid;
        }
      });
  } catch (error) {
    ElMessage.error("获取用户信息失败");
  }
};

interface RuleForm {
  uuid: string; // 用户唯一标识
  uname: string; // 用户名
  company: string;
  job_title: string;
  avatar_url: string;
  blog_address: string;
  description: string;
}
const ruleFormRef = ref<FormInstance>();

const form = reactive<RuleForm>({
  uuid: "",
  uname: "",
  company: "",
  job_title: "",
  avatar_url: "",
  blog_address: "",
  description: ""
});

onMounted(() => {
  activeTab.value = "all";
  fetchUserInfo(); // 替换为实际的用户 ID
});

const rules = reactive<FormRules<RuleForm>>({
    uname: [{ required: true, message: "请输入用户名", trigger: "blur" }]
});

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      let params = {
        uname: form.uname,
        job_title: form.job_title,
        ucompany: form.company,
        blog_address: form.blog_address,
        description: form.description,
        uuid: form.uuid
      };
      axiosInstance
        .post("api/UserInfo/UpdateUserProfile", params)
        .then((res) => {
          var result = res.data;
          if (result.success) {
            ElMessage.success(result.msg);
            userInfo.value.audit_status = 2;
            //router.push({ path: "/user/settings/profile"});
            fetchUserInfo()
          }
          else {
            ElMessage.error(result.msg);
          }
        });
    } else {
      console.log("error!");
    }
  });
};
</script>

<style scoped>
.creator-center {
  width: 100%;
  height: 100%;
}
.header {
  justify-content: space-between;
  padding: 0 20px;
  background: #fff;
  transform: translateZ(0);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  transition: transform 0.2s;
  z-index: 250;
}
.main-container {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  margin-top: 22px;
}

.right-wrap {
  width: 980px;
  margin-left: 220px;
}

.main-content {
  min-height: calc(100vh - 108px);
  margin-bottom: 24px;
  padding: 0 20px;
  background: #fff;
  margin-top: 59px;
}

.tab-nav {
  position: relative;
  margin-bottom: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 1px solid #dcdfe6;
}
.leftitem {
  position: relative;
  z-index: 1;
  float: left;
  white-space: nowrap;
  width: 200px;
}
.el-tabs {
  --el-tabs-header-height: 56px !important;
  line-height: 56px !important;
  vertical-align: top !important;
  margin-bottom: 0px 0px 0px 0px !important;
}

.leftitem ::v-deep .el-tabs__header {
  margin-bottom: 0px;
}
.leftitem ::v-deep .el-tabs__item {
  font-size: 16px;
}
.leftitem ::v-deep .el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #cc5656;
}
.leftitem ::v-deep .el-tabs__active-bar {
  background-color: #cc5656;
}
.rightitem {
  display: flex;
  align-items: center;
}

.user-profile-container {
  padding: 20px;
  background: #fff;
}

.nav-menu {
  border-right: none;
}

.profile-content {
  display: flex;
  padding: 20px;
}

.user-info-form {
  flex: 1;
  padding-right: 40px;
}

.avatar-upload {
  width: 240px;
  text-align: center;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  padding: 20px;
  cursor: pointer;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
}

.avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}

.upload-tips {
  color: #999;
  font-size: 12px;
  margin-top: 10px;
}

/* 用户头像 */
.RC-con-a .RC-con-a-list {
  /* display: flex; */
  /* justify-content: center; */
  /* padding-bottom: 20px; */
  width: 565px;
}
.RC-con-a .RC-con-a-list-item {
  display: block;
  float: left;
  flex-direction: column;
  align-items: center;
  min-width: 94px;
  cursor: pointer;
}
.RC-con-a .RC-con-a-list-item:nth-child(4) > span {
  background-position: 0 -139px;
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-avatar {
  display: inline-block;
  width: 64px;
  height: 64px;
  margin-bottom: 10px;
  border-radius: 50%;
  position: relative;
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-icon {
  display: inline-block;
  width: 64px;
  height: 64px;
  background: url("") center top no-repeat;
  background-size: 64px 203px;
  margin-bottom: 10px;
  border-radius: 50%;
  position: relative;
  background-position: 0 -69px;
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-icon .M-icon {
  position: absolute;
  right: -1px;
  bottom: -1px;
  font-size: 1.6em;
}
.M-icon-check::before {
  background-position: -0.8333333333333334em -3.3333333333333335em;
  width: 0.8333333333333334em;
  height: 0.8333333333333334em;
}
.M-icon::before {
  display: inline-block;
  background-image: url(@/assets/user/check_full.png);
}
.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-icon .M-icon {
  font-size: 1.6em;
}
.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-avatar .M-icon {
  font-size: 1.875em;
}
.RC-con-a .RC-con-a-list-item .item-text {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  line-height: 18px;
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-avatar {
  position: relative;
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-avatar .M-icon-check {
  width: 0.8333333333333334em;
  height: 0.8333333333333334em;
  position: absolute;
  top: 42px;
  right: -16%;
  transform: translateX(-50%);
  color: #67c23a;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2;
  background-image: url(@/assets/user/check_full.png);
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-avatar img {
  position: relative;
  z-index: 1;
}
.el-button--danger {
  background-color: #cc5656;
  border-color: #cc5656;
  color: #fff;
  cursor: pointer;
  padding: 2px 16px;
  font-size: 14px;
  line-height: 22px;
  border-radius: 2px;
}
</style>
